import React from 'react';
import './layer-togglers.scss';
import LayerToggleControl, { LayerToggleRadio } from './layer-toggler';
import { UnitsVisibility } from './types/units-visibility';

const LayerTogglers = props => {
    return (
        <div className="layer-togglers">
            <LayerToggleControl title={`Visar`}>
                <LayerToggleRadio
                    label={`Dölj ${props.type === 'foodservice' ? 'enheter' : 'butiker'}`}
                    checked={props.unitsVisible === UnitsVisibility.NONE}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.NONE)}
                />
                <LayerToggleRadio
                    label={`Alla ${props.type === 'foodservice' ? 'enheter' : 'butiker'}`}
                    checked={props.unitsVisible === UnitsVisibility.ALL}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.ALL)}
                />
                <LayerToggleRadio
                    label={`${props.type === 'foodservice' ? 'Enheter' : 'Butiker'} i säljdistrikt inklusive prospects`}
                    checked={props.unitsVisible === UnitsVisibility.AREA}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.AREA)}
                />
                <LayerToggleRadio
                    label={`${props.type === 'foodservice' ? 'Enheter' : 'Butiker'} som endast ingår i säljdistrikt`}
                    checked={props.unitsVisible === UnitsVisibility.AREA_STRICT}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.AREA_STRICT)}
                />
            </LayerToggleControl>
     
            {/*<LayerToggleControl title="Visa kartlager">
                <LayerToggleCheckbox
                    label="Visa säljdistrikt"
                    checked={props.saleDistrictsVisible}
                    onChange={(e) => props.toggleSaleDistrict(e)}
                />
            </LayerToggleControl>*/}
        </div>
    );
};

export default LayerTogglers;